import { useSelector, useDispatch } from "react-redux"
import { setSport } from "redux/slices/generator"

export default function SportInput() {

    const dispatch = useDispatch()
    const sport = useSelector((state) => state.generator.inputs.sport)

    return (
        <div className="flex items-center gap-x-2">
            <div className="w-20">Sport: </div>
            <select 
                id="sport" 
                value={sport} 
                onChange={(event) => dispatch(setSport(event.target.value))} 
                className='w-full px-4 py-2 rounded-md text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400'
            >
                <option value="five-kilometer-running">5k</option>
                <option value="ten-kilometer-running">10k</option>
                <option value="cross-country">Cross Country Running</option>
                <option value="half-marathon">Half Marathon</option>
                <option value="triathlon">Triathlon</option>
                <option value="trail-running">Trail Running</option>
                <option value="marathon">Marathon</option>
                <option value="ultra-marathon">Ultra Marathon</option>
                <option value="cycling">Cycling</option>
                <option value="swimming">Swimming</option>
            </select>
        </div>
    )
}